import React, { useState } from 'react'
import { Button, Modal, Table } from 'react-bootstrap'

// port of cowebapp components/email_finder/helper.js ConfidenceScoreInfoIcon
// (reactstrap Modal → react-bootstrap; the score table is static content)
export const ConfidenceScoreInfoIcon = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const onInfoIconClick = (e) => {
    if (e) e.stopPropagation()
    setIsModalOpen(!isModalOpen)
  }

  const data = [
    {
      score_range: '>= 90',
      meaning: 'Very high accuracy, strong match with lead details',
      deliverablility_risk: 'Very Low',
      typical_cases: 'Valid corporate emails, consistent patterns, verified domains',
      recommended_use: 'High-value outreach, sales sequences, important campaigns'
    },
    {
      score_range: '80 - 90',
      meaning: 'Generally accurate with mild risk',
      deliverablility_risk: 'Low - Medium',
      typical_cases: 'Accept-all domains, strict mail servers, mixed signals',
      recommended_use: 'Newsletters, warming sequences, prospecting'
    },
    {
      score_range: '< 80',
      meaning: 'Low accuracy, weak match or poorly configured domains',
      deliverablility_risk: 'High',
      typical_cases: 'Temporary emails, low-trust domains, inconsistencies',
      recommended_use: 'Low-priority tasks, verification-only flows'
    },
  ]

  return (
    <>
      <Button
        variant="link"
        className="p-0"
        onClick={onInfoIconClick}
      >
        <span className="all-status-help-tip"></span>
      </Button>
      <Modal
        show={isModalOpen}
        onHide={onInfoIconClick}
        size="xl"
        centered
        className="ef-confidence-score-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Understanding the Email Finder Confidence Score</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            Email Finder <span className="bold-font">Confidence Score</span> is an AI-driven indicator that shows how accurately the discovered email address matches your lead&apos;s information (name, domain, company name) and it is calculated in real time by analyzing multiple data points and using advanced machine learning algorithms.
          </div>
          <div className="table-responsive ef-history-table">
            <Table
              borderless
              hover
            >
              <thead>
                <tr>
                  <th style={{ width: '10%' }}>Score</th>
                  <th>Meaning</th>
                  <th>Deliverablility Risk</th>
                  <th>Typical Cases</th>
                  <th>Recommended Use</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row) => (
                  <tr key={row.score_range}>
                    <td>{row.score_range}</td>
                    <td>{row.meaning}</td>
                    <td>{row.deliverablility_risk}</td>
                    <td>{row.typical_cases}</td>
                    <td>{row.recommended_use}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div>
            <div className="bold-font">Quick Note</div>
            <div>Higher score = higher trust, better deliverability, and stronger alignment with true lead identity.</div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
